import { Navigate } from "react-router-dom";
import { useAuth } from "../context/authContext";
import { getDefaultRoute } from "../access";
import Dashboard from "../pages/Dashboard";

/**
 * Ruta raíz y fallback: dashboard operativo, o el home de la cuenta.
 */
export default function HomeRoute() {
  const { user, effectiveUser } = useAuth();
  const home = getDefaultRoute(effectiveUser || user);

  if (home !== "/") {
    return <Navigate to={home} replace />;
  }

  return <Dashboard />;
}
